import BugReporting from './BugReporting.vue'

export { BugReporting }
export default BugReporting
